import type { ShellFlexPane } from '@1js/suiteux-shell-react';
import { content } from 'owa-header-pane/lib/components/HeaderPane.scss';
import loc from 'owa-localize';
import { helpCharm_ariaLabel } from 'owa-locstrings/lib/strings/helpcharm_arialabel.locstring.json';
import { customFlexPane } from 'owa-suite-header/lib/components/OwaSuiteHeader.scss';
import { OwaHelpButtonID, OwaHelpFlexPaneID } from 'owa-suite-header/lib/constants';
import createShellFlexPane from 'owa-suite-header/lib/utils/createShellFlexPane';
import renderInsideFlexPane from 'owa-suite-header/lib/utils/renderInsideFlexPane';
import React from 'react';
import HelpContent from './HelpContent';

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function createShellFlexPane called at module scope is not allowed. This may cause unwanted side effects. */
const HelpFlexPane = createShellFlexPane({
    flexPaneID: OwaHelpFlexPaneID,
    flexPaneTitle: () => loc(helpCharm_ariaLabel),
    triggerControlID: OwaHelpButtonID,
    containerClassName: customFlexPane,
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function renderInsideFlexPane called at module scope is not allowed. This may cause unwanted side effects.
     *	> Function loc called at module scope is not allowed. This may cause unwanted side effects. */
    render: renderInsideFlexPane(<HelpContent />, loc(helpCharm_ariaLabel), content),
} as ShellFlexPane);

export default HelpFlexPane;
